import PropertySection from 'framework-asset-preview-lib/internal/properties/components/propertySections/PropertySection';
import EmptyPropertyValue from 'framework-asset-preview-lib/internal/properties/components/propertyValues/EmptyPropertyValue';
import ResolvedPropertyValue from 'framework-asset-preview-lib/internal/properties/components/propertyValues/ResolvedPropertyValue';
import { getPropertyValue } from 'framework-asset-preview-lib/internal/shared/utils/crmObject';
import UserAvatar from 'framework-asset-preview-lib/internal/shared/components/UserAvatar';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Shared user property section for all object types that need to render a "Created by", "Updated by" property.
 * This component is meant to be used inside of any [AssetName]PreviewSidepanel or [AssetName]PreviewPopover component.
 */
export default function UserPropertySection({
  crmObject,
  getValue,
  properties,
  propertyName,
  resolvedObjectType,
  renderLabelBadge
}) {
  return /*#__PURE__*/_jsx(PropertySection, {
    crmObject: crmObject,
    properties: properties,
    propertyName: propertyName,
    renderValue: () => {
      const propertyValue = getValue ? getValue() : getPropertyValue(crmObject, propertyName, '');
      if (!propertyValue) {
        return /*#__PURE__*/_jsx(EmptyPropertyValue, {});
      }
      return /*#__PURE__*/_jsx(ResolvedPropertyValue, {
        id: `${propertyValue}`,
        objectType: resolvedObjectType,
        children: reference => {
          return /*#__PURE__*/_jsx(UserAvatar, {
            email: reference.description,
            name: reference.label
          });
        }
      });
    },
    renderLabelBadge: renderLabelBadge
  });
}